import actionTypes from "../actionTypes";

const fetch = () => {
  return {
    type: actionTypes.billingInformation.FETCH
  };
}

const fetchOk = (data) => {
  return {
    type: actionTypes.billingInformation.FETCH_OK,
    data: data
  };
}

const fetchError = (error) => {
  return {
    type: actionTypes.billingInformation.FETCH_ERROR,
    error: error
  };
}

export const billingInfoActions = {
  fetch,
  fetchOk,
  fetchError
};